export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const BUCKET_OPTIONS = [
  { value: 'operational', label: 'Operational' },
  { value: 'spare', label: 'Spare' },
  { value: 'scrap_recyclable', label: 'Scrap / Recyclable' },
];

export const UNIT_OPTIONS = [
  'meters',
  'units',
  'kgs',
  'liters',
];

export const CURRENCY_OPTIONS = ['USD', 'EUR', 'GBP', 'JPY', 'AED', 'SAR', 'INR'];

export const OPERATIONAL_STATUS_OPTIONS = ['active', 'inactive'];
export const SPARE_STATUS_OPTIONS = ['active', 'inactive'];
export const SCRAP_STATUS_OPTIONS = ['to_be_recycled', 'recycled'];

export const COMPONENT_TYPE_OPTIONS = [
  'module',
  'inverter',
  'cable',
  'combiner_box',
  'transformer',
  'mounting_structure',
  'sensor',
  'other',
];

export function normalizeUnit(unit) {
  const value = (unit || '').toLowerCase();
  if (!value) return 'units';
  if (value === 'piece') return 'units';
  if (value === 'meter') return 'meters';
  if (value === 'kg') return 'kgs';
  if (value === 'litre') return 'liters';
  if (value === 'liter') return 'liters';
  if (UNIT_OPTIONS.includes(value)) return value;
  return 'units';
}

export const emptyComponentForm = {
  bucket: 'operational',
  name: '',
  type: 'other',
  manufacturer_id: 'none',
  manufacturer: '',
  model: '',
  serial_number: '',
  quantity: 0,
  unit: 'units',
  status: 'active',
  oem_datasheet_url: '',
  notes: '',
  asset_id: 'none',
  parent_component_id: 'none',
  installation_date: '',
  warranty_expiry_date: '',
  last_pm_date: '',
  next_pm_date: '',
  tilt: '',
  azimuth: '',
  dc_capacity_kw: '',
  ac_capacity_kw: '',
  safety_quantity: '',
  expiry_date: '',
  manufacturing_date: '',
  last_maintenance_date: '',
  next_maintenance_date: '',
  recycled_date: '',
  recycled_name: '',
  amount_received: '',
  amount_currency: 'USD',
};

export function getStatusBadgeClass(bucket, status) {
  if (bucket === 'operational') {
    return status === 'active'
      ? 'bg-emerald-100 text-emerald-700 border-emerald-300'
      : 'bg-slate-100 text-slate-600 border-slate-300';
  }
  if (bucket === 'spare') {
    return status === 'active'
      ? 'bg-emerald-100 text-emerald-700 border-emerald-300'
      : 'bg-slate-100 text-slate-600 border-slate-300';
  }
  if (bucket === 'scrap_recyclable') {
    return status === 'recycled'
      ? 'bg-indigo-100 text-indigo-700 border-indigo-300'
      : 'bg-amber-100 text-amber-700 border-amber-300';
  }
  return 'bg-slate-100 text-slate-600 border-slate-300';
}

export function bucketLabel(bucket) {
  if (bucket === 'operational') return 'Operational';
  if (bucket === 'spare') return 'Spare';
  if (bucket === 'scrap_recyclable') return 'Scrap / Recyclable';
  return bucket || 'Unknown';
}

export function normalizeComponentPayload(form) {
  const payload = { ...form };

  payload.unit = normalizeUnit(payload.unit);

  payload.asset_id = form.asset_id === 'none' ? null : form.asset_id;
  payload.parent_component_id = form.parent_component_id === 'none' ? null : form.parent_component_id;
  payload.manufacturer_id = form.manufacturer_id === 'none' ? null : form.manufacturer_id;

  const numberFields = [
    'quantity',
    'tilt',
    'azimuth',
    'dc_capacity_kw',
    'ac_capacity_kw',
    'safety_quantity',
    'amount_received',
  ];

  numberFields.forEach((field) => {
    if (payload[field] === '' || payload[field] === null || payload[field] === undefined) {
      payload[field] = null;
      return;
    }
    const parsed = Number(payload[field]);
    payload[field] = Number.isNaN(parsed) ? null : parsed;
  });

  const nullableDateFields = [
    'installation_date',
    'warranty_expiry_date',
    'last_pm_date',
    'next_pm_date',
    'expiry_date',
    'manufacturing_date',
    'last_maintenance_date',
    'next_maintenance_date',
    'recycled_date',
  ];

  nullableDateFields.forEach((field) => {
    if (!payload[field]) {
      payload[field] = null;
    }
  });

  if (payload.bucket === 'operational' && !payload.status) {
    payload.status = 'active';
  }
  if (payload.bucket === 'spare' && !payload.status) {
    payload.status = 'active';
  }
  if (payload.bucket === 'scrap_recyclable' && !payload.status) {
    payload.status = 'to_be_recycled';
  }

  return payload;
}
